// extracted by mini-css-extract-plugin
export default {"container":"ProjectDetails_container__vc32W","buttons":"ProjectDetails_buttons__OIFA-","close":"ProjectDetails_close__UZHgb","video":"ProjectDetails_video__OBwo1"};